import { GlobalPopoverStyles } from './GlobalPopoverStyles';
import { GlobalAlertStyles } from './GlobalAlertStyles';
import { GlobalButtonStyles } from './GlobalButtonStyles';
import { GlobalDialogHeaderStyles } from './GlobalDialogHeaderStyles';
import { GlobalFontStyles } from './GlobalFontStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GlobalPortalStyles = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalPopoverStyles, {}), /*#__PURE__*/_jsx(GlobalAlertStyles, {}), /*#__PURE__*/_jsx(GlobalButtonStyles, {}), /*#__PURE__*/_jsx(GlobalDialogHeaderStyles, {}), /*#__PURE__*/_jsx(GlobalFontStyles, {})]
  });
};